import useAuth from "../../../hooks/useAuth";
import { breakValue } from "../../smallFunction/SmallFunctions";
import { lastToNextDateFunction } from "./relativeDates/lastToNextDateFunction";
import { thisToThisDateFunction } from "./relativeDates/thisToThisDateFunction";

const buildSortObject = (vizType, groupByKeys, rowKeys) => {
  let sortObject = null;
  const groupZeroIndexItem = groupByKeys[0];
  const rowZeroIndexItem = rowKeys[0];
  // // console.log(rowZeroIndexItem);
  // // console.log(groupZeroIndexItem);

  switch (vizType) {
    case "cordinatemap":
      sortObject = { isRandomSort: true };
      break;
    case "simpleTable":
      if (rowKeys.length && groupByKeys.length === 0) {
        if (rowZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: rowZeroIndexItem.columnName,
            order: "ASC",
            format: rowZeroIndexItem.format,
            yearType: rowZeroIndexItem.yearType,
          };
        }
        if (rowZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: rowZeroIndexItem.responseKey,
            order: "ASC",
            format: rowZeroIndexItem.format,
          };
        }
        if (rowZeroIndexItem.dataType === "Number") {
          sortObject = {
            columnName: rowZeroIndexItem.responseKey,
            order: "ASC",
          };
        }
      }
    case "piechart":
    case "linechart":
    case "areachart":
    case "stackedbarchart":
    case "scatterchart":
    case "combochart":
    case "funnelchart":
    case "disktreechart":
    case "wordcloudchart":
    case "heatmapchart":
    case "stackedbarchartimage":
      if (groupByKeys.length && rowKeys.length === 0) {
        if (groupZeroIndexItem.dataType === "Date") {
          sortObject = {
            columnName: groupZeroIndexItem.columnName,
            order: "ASC",
            format: groupZeroIndexItem.format,
            yearType: groupZeroIndexItem.yearType,
          };
        }
        if (groupZeroIndexItem.dataType === "String") {
          sortObject = {
            columnName: groupZeroIndexItem.responseKey,
            order: "ASC",
            format: groupZeroIndexItem.format,
          };
        }
        if (groupZeroIndexItem.dataType === "Number") {
          sortObject = {
            columnName: groupZeroIndexItem.responseKey,
            order: "ASC",
          };
        }
      }
    default:
      break;
  }
  // // console.log(sortObject);
  if (sortObject) {
    return [sortObject];
  } else {
    return [];
  }
};

export const buildQuery = (
  workbookReduxState,
  dataSourceID,
  commonFilters = [],
  sortProperties = [],
  rowLimit,
  vizType,
  offset,
  user_id
) => {

  const rowsReduxArray = workbookReduxState.rows || [];
  const columnsReduxArray = workbookReduxState.groupByFields || [];
  const valuesReduxArray = workbookReduxState.valueColumns || [];
  const filtersReduxArray = workbookReduxState.filters || [];
  const tooltipReduxArray = workbookReduxState.tooltip || [];

  // const workBookReduxFiltersArray = []

  let queryBody = {
    dataSourceID,
    limit: Number(rowLimit) || 500,
    offset: offset ?? 0,
  };

  let rowKeys = [];
  let groupByKeys = [];
  let valueKeys = [];
  let toolTipKeys = [];
  const filters = [];
  let sortBy = [];
  const checkIfItemExists = (item) => {
    return item && Array.isArray(item) && item.length;
  };

  // Build rows array
  if (checkIfItemExists(rowsReduxArray)) {
    const rows = [];
    rowKeys = [];
    rowsReduxArray.forEach((element) => {
      // console.log(element);

      const format = element.dateFormat?.value;
      const columnName = element.columnName;
      const fieldType = element.columnType;
      const formula = element.formula;
      const dateUnit = element.dateUnit;
      const yearType = element.yearType;
      // console.log({
      //   format,
      //   columnName,
      //   fieldType,
      //   formula,
      //   dateUnit,
      //   yearType,
      // });

      const rowColumnObject = {
        format,
        columnName,
        fieldType,
        formula,
        dateUnit,
        yearType,
      };
      rows.push(rowColumnObject);
      const rename = element.rename;

      const responseKey = format ? rename + format : rename;

      const rowProperties = {
        responseKey,
        caption: rename,
        rename: rename,
        columnName: element.columnName,
        dataType: element.dataType,
        uuid: element.uuid,
        format: element.dateFormat?.value,
        _id: element._id,
        columnType: element.columnType,
        formula: element.formula,
        dateUnit,
        dateFormat: element.dateFormat,
        nanoId: element.nanoId,
        yearType: element.yearType,
      };
      // console.log(rowProperties);
      // console.log(element);

      rowKeys.push(rowProperties);
    });
    queryBody.rows = rows;
  }

  // Build columns array
  if (checkIfItemExists(columnsReduxArray)) {
    const groupByFields = [];
    groupByKeys = [];
    columnsReduxArray.forEach((element) => {
      // console.log(element);

      const format = element.dateFormat?.value;
      const columnName = element.columnName;
      const fieldType = element.columnType;
      const formula = element.formula;
      const dateUnit = element.dateUnit;
      const yearType = element.yearType;
      const ColumnObject = {
        format,
        columnName,
        fieldType,
        formula,
        dateUnit,
        yearType,
      };
      groupByFields.push(ColumnObject);
      const rename = element.rename;
      const responseKey = format ? rename + format : rename;
      const columnProperties = {
        responseKey,
        caption: rename,
        rename: rename,
        dataType: element.dataType,
        uuid: element.uuid,
        format: element.dateFormat?.value,
        columnName,
        formula,
        columnType: fieldType,
        dateUnit,
        dateFormat: element.dateFormat,
        _id: element._id,
        nanoId: element.nanoId,
        yearType: element.yearType,
        coordinateType: element.coordinateType,
      };
      groupByKeys.push(columnProperties);
    });
    queryBody.groupByFields = groupByFields;
  }

  // Build Value array
  if (checkIfItemExists(valuesReduxArray)) {
    // console.log(valuesReduxArray);
    const valueColumns = [];
    valueKeys = [];
    valuesReduxArray.forEach((element) => {
      if (element.dataType === "Number" || element.dataType === "String") {
        const value = element.measure.value;
        const columnName = element.columnName;
        const fieldType = element.columnType;
        const formula = element.formula;

        const valueColumnObject = { value, columnName, fieldType, formula };
        valueColumns.push(valueColumnObject);
        // const responseKey = `${element.measure.value}_${element.rename}`;
        const numberProperties = {
          dataType: element.dataType,
          caption: element.rename,
          numberFormat: element.numberObject,
          responseKey: `${element.measure.value}_${element.rename}`,
          _id: element._id,
          columnName: element.columnName,
          measure: element.measure,
          display: element.display,
          independentAxis: element.independentAxis,
          horizontalLineBar: element.horizontalLineBar,

          nanoId: element.nanoId,
          formula: element.formula,
          columnType: element.columnType,
        };

        valueKeys.push(numberProperties);
      } else {
        // console.log(element);
        const valueColumnObject = {
          value: element?.measure?.value,
          columnName: element?.columnName,
          format: element?.dateFormat?.value,
          yearType: element?.yearType,
        };
        valueColumns.push(valueColumnObject);
        const numberProperties = {
          dataType: element?.dataType,
          caption: element?.rename,
          numberFormat: element?.numberObject,
          responseKey: `${element?.measure?.value}_${element?.rename}${element?.dateFormat?.value}`,
          _id: element._id,
          value: element?.measure?.value,
          columnName: element?.columnName,
          measure: element?.measure?.value,
          display: element?.display,
          independentAxis: element?.independentAxis,
          nanoId: element?.nanoId,
          dateFormat: element?.dateFormat,
          yearType: element?.yearType,
          dateUnit: element?.dateUnit,
          columnType: element?.columnType,
        };
        // console.log(numberProperties);
        valueKeys.push(numberProperties);
      }
    });
    queryBody.valueColumns = valueColumns;
  }

  //build tooltip
  if (checkIfItemExists(tooltipReduxArray)) {
    const tooltip = [];
    toolTipKeys = [];
    tooltipReduxArray.forEach((element) => {
      const value = element.measure.value;
      const columnName = element.columnName;
      const fieldType = element.columnType;
      const formula = element.formula;
      const toolTipColumnObject = { value, columnName, fieldType, formula };
      tooltip.push(toolTipColumnObject);
      const responseKey = `${element.measure.value}_${element.rename}`;
      const NumberObj = element.numberObject?.decimalPlaces;
      // // console.log(NumberObj);
      const toolTipKeypair = {
        responseKey,
        NumberObj,
        numberFormat: element.numberObject,
        caption: columnName,
        columnType: fieldType,
      };
      toolTipKeys.push(toolTipKeypair);
    });
    queryBody.tooltip = tooltip;
  }

  // Build filters array
  if (checkIfItemExists(filtersReduxArray)) {
    // // console.log(filtersReduxArray);
    filtersReduxArray.forEach((element) => {
      // console.log(element);
      const filterDataSourceID = element.dataSourceID;
      const fieldType = element.columnType;
      const formula = element.formula;

      let filterObject = null; // Start with null to conditionally push only defined objects
      if (filterDataSourceID) {
        if (filterDataSourceID === dataSourceID) {
          // console.log("filter will apply");
          switch (element.selectedOperator) {
            case "IN":
              if (!element.isAll) {
                // Only create filterObject if isAll is false
                if (element.dataType === "Date") {
                  filterObject = {
                    columnName: element.columnName,
                    minValue: element.selectedFilterValues.map((selectedItem) =>
                      selectedItem === "NULL"
                        ? null
                        : selectedItem === "BLANK"
                          ? ""
                          : selectedItem
                    ),
                    operator: element.selectedOperator,
                    format: element.format,
                    fieldType,
                    formula,
                  };
                } else {
                  filterObject = {
                    columnName: element.columnName,
                    minValue: element.selectedFilterValues.map((selectedItem) =>
                      selectedItem === "NULL"
                        ? null
                        : selectedItem === "BLANK"
                          ? ""
                          : selectedItem
                    ),
                    operator: element.selectedOperator,
                    fieldType,
                    formula,
                  };
                }
              } else {
                console.error(
                  "filters isAll flag is true so filter is not present in query, only present in Redux"
                );
              }
              break;
            case "BETWEEN":
              if (element.dataType === "Date") {
                if (element.isRelativeDate) {
                  // console.log(element.relativeDateIs, element.dateUnit);
                  if (element.relativeDateIs && element.dateUnit) {
                    const result = breakValue(
                      element.relativeDateIs,
                      "buildQuery"
                    );
                    if (result) {
                      const { period, value, unit } = result;
                      // console.log(period, value, unit);
                      const { minValue, maxValue } = lastToNextDateFunction({
                        period,
                        value,
                        unit,
                      });

                      filterObject = {
                        columnName: element.columnName,
                        operator: element.selectedOperator,
                        format: "DD/MM/YYYY",
                        minValue: minValue,
                        maxValue: maxValue,
                      };
                    } else {
                      // console.log(result);
                      // console.log(element);
                      // console.log(element.relativeDateIs);
                      // console.log(element.dateUnit);
                      const { minValue, maxValue } = thisToThisDateFunction(
                        element.relativeDateIs,
                        element.dateUnit
                      );
                      // console.log({ minValue, maxValue });
                      filterObject = {
                        columnName: element.columnName,
                        operator: element.selectedOperator,
                        format: "DD/MM/YYYY",
                        minValue: minValue,
                        maxValue: maxValue,
                      };
                    }
                  } else {
                    console.error(
                      "relativeDate can empty string or undefined or null "
                    );
                  }
                } else {
                  // buildReduxState minValue and maxValue is alreadyPrsent
                  if (element.minValue && element.maxValue) {
                    // console.log({
                    //   columnName: element.columnName,
                    //   operator: element.selectedOperator,
                    //   format: "DD/MM/YYYY",
                    //   minValue: element.minValue,
                    //   maxValue: element.maxValue,
                    // });

                    filterObject = {
                      columnName: element.columnName,
                      operator: element.selectedOperator,
                      format: "DD/MM/YYYY",
                      minValue: element.minValue,
                      maxValue: element.maxValue,
                    };
                  }
                }
              } else {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.minValue,
                  maxValue: element.maxValue,
                  operator: element.selectedOperator,
                  measure: element.selectedMeasure,
                  fieldType,
                  formula,
                };
              }
              break;
            default:
              filterObject = {
                columnName: element.columnName,
                minValue: element.minValue,
                operator: element.selectedOperator,
                measure: element.selectedMeasure,
                fieldType,
                formula,
              };
              break;
          }
          // Only push filterObject if it was created (not null)
          // console.log(filterObject);
          if (filterObject) {
            filters.push(filterObject);
          }
        } else {
          console.error(
            "filter will not apply because the dataSourceID of sheet and filter is not same or null"
          );
        }
      } else {
        // console.log("filter will apply");
        switch (element.selectedOperator) {
          case "IN":
            if (!element.isAll) {
              // Only create filterObject if isAll is false
              if (element.dataType === "Date") {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.selectedFilterValues.map((selectedItem) =>
                    selectedItem === "NULL"
                      ? null
                      : selectedItem === "BLANK"
                        ? ""
                        : selectedItem
                  ),
                  operator: element.selectedOperator,
                  format: element.format,
                  fieldType,
                  formula,
                };
              } else {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.selectedFilterValues.map((selectedItem) =>
                    selectedItem === "NULL"
                      ? null
                      : selectedItem === "BLANK"
                        ? ""
                        : selectedItem
                  ),
                  operator: element.selectedOperator,
                  fieldType,
                  formula,
                };
              }
            } else {
              console.error(
                "filters isAll flag is true so filter is not present in query, only present in Redux"
              );
            }
            break;
          case "BETWEEN":
            if (element.dataType === "Date") {
              if (element.isRelativeDate) {
                // // console.log("relative is true");
                // console.log(element.relativeDateIs, element.dateUnit);
                const result = breakValue(element.relativeDateIs, "buildQuery");
                if (result) {
                  const { period, value, unit } = result;
                  // console.log(period, value, unit);
                  const { minValue, maxValue } = lastToNextDateFunction({
                    period,
                    value,
                    unit,
                  });

                  filterObject = {
                    columnName: element.columnName,
                    operator: element.selectedOperator,
                    format: "DD/MM/YYYY",
                    minValue: minValue,
                    maxValue: maxValue,
                  };
                } else {
                  // console.log(result);
                  const { minValue, maxValue } = thisToThisDateFunction(
                    element.relativeDateIs,
                    element.dateUnit
                  );
                  filterObject = {
                    columnName: element.columnName,
                    operator: element.selectedOperator,
                    format: "DD/MM/YYYY",
                    minValue: minValue,
                    maxValue: maxValue,
                  };
                }
              } else {
                // buildReduxState minValue and maxValue is alreadyPrsent
                if (element.minValue && element.maxValue) {
                  // console.log({
                  //   columnName: element.columnName,
                  //   operator: element.selectedOperator,
                  //   format: "DD/MM/YYYY",
                  //   minValue: element.minValue,
                  //   maxValue: element.maxValue,
                  // });

                  // filterObject = {
                  //   columnName: element.columnName,
                  //   operator: element.selectedOperator,
                  //   format: "DD/MM/YYYY",
                  //   minValue:element.minValue,
                  //   maxValue: element.maxValue,
                  // };
                }
              }
            } else {
              filterObject = {
                columnName: element.columnName,
                minValue: element.minValue,
                maxValue: element.maxValue,
                operator: element.selectedOperator,
                measure: element.selectedMeasure,
                fieldType,
                formula,
              };
            }
            break;
          default:
            filterObject = {
              columnName: element.columnName,
              minValue: element.minValue,
              operator: element.selectedOperator,
              measure: element.selectedMeasure,
              fieldType,
              formula,
            };
            break;
        }
        // Only push filterObject if it was created (not null)
        if (filterObject) {
          filters.push(filterObject);
        }
      }
    });
  }
  //add common filters
  if (checkIfItemExists(commonFilters)) {
    commonFilters.forEach((element) => {
      // console.log(element);
      const filterDataSourceID = element.dataSourceID;
      const fieldType = element.columnType;
      const formula = element.formula;

      let filterObject = null; // Start with null to conditionally push only defined objects
      if (filterDataSourceID) {
        if (filterDataSourceID === dataSourceID) {
          // console.log("filter will apply");
          switch (element.selectedOperator) {
            case "IN":
              if (!element.isAll) {
                // Only create filterObject if isAll is false
                if (element.dataType === "Date") {
                  filterObject = {
                    columnName: element.columnName,
                    minValue: element.selectedFilterValues.map((selectedItem) =>
                      selectedItem === "NULL"
                        ? null
                        : selectedItem === "BLANK"
                          ? ""
                          : selectedItem
                    ),
                    operator: element.selectedOperator,
                    format: element.format,
                    fieldType,
                    formula,
                  };
                } else {
                  filterObject = {
                    columnName: element.columnName,
                    minValue: element.selectedFilterValues.map((selectedItem) =>
                      selectedItem === "NULL"
                        ? null
                        : selectedItem === "BLANK"
                          ? ""
                          : selectedItem
                    ),
                    operator: element.selectedOperator,
                    fieldType,
                    formula,
                  };
                }
              } else {
                console.error(
                  "filters isAll flag is true so filter is not present in query, only present in Redux"
                );
              }
              break;
            case "BETWEEN":
              if (element.dataType === "Date") {
                if (element.isRelativeDate) {
                  // console.log(element.relativeDateIs, element.dateUnit);
                  if (element.relativeDateIs && element.dateUnit) {
                    const result = breakValue(
                      element.relativeDateIs,
                      "buildQuery"
                    );
                    if (result) {
                      const { period, value, unit } = result;
                      // console.log(period, value, unit);
                      const { minValue, maxValue } = lastToNextDateFunction({
                        period,
                        value,
                        unit,
                      });

                      filterObject = {
                        columnName: element.columnName,
                        operator: element.selectedOperator,
                        format: "DD/MM/YYYY",
                        minValue: minValue,
                        maxValue: maxValue,
                      };
                    } else {
                      // console.log(result);
                      // console.log(element);
                      // console.log(element.relativeDateIs);
                      // console.log(element.dateUnit);
                      const { minValue, maxValue } = thisToThisDateFunction(
                        element.relativeDateIs,
                        element.dateUnit
                      );
                      // console.log({ minValue, maxValue });
                      filterObject = {
                        columnName: element.columnName,
                        operator: element.selectedOperator,
                        format: "DD/MM/YYYY",
                        minValue: minValue,
                        maxValue: maxValue,
                      };
                    }
                  } else {
                    console.error(
                      "relativeDate can empty string or undefined or null "
                    );
                  }
                } else {
                  // buildReduxState minValue and maxValue is alreadyPrsent
                  if (element.minValue && element.maxValue) {
                    // console.log({
                    //   columnName: element.columnName,
                    //   operator: element.selectedOperator,
                    //   format: "DD/MM/YYYY",
                    //   minValue: element.minValue,
                    //   maxValue: element.maxValue,
                    // });

                    filterObject = {
                      columnName: element.columnName,
                      operator: element.selectedOperator,
                      format: "DD/MM/YYYY",
                      minValue: element.minValue,
                      maxValue: element.maxValue,
                    };
                  }
                }
              } else {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.minValue,
                  maxValue: element.maxValue,
                  operator: element.selectedOperator,
                  measure: element.selectedMeasure,
                  fieldType,
                  formula,
                };
              }
              break;
            default:
              filterObject = {
                columnName: element.columnName,
                minValue: element.minValue,
                operator: element.selectedOperator,
                measure: element.selectedMeasure,
                fieldType,
                formula,
              };
              break;
          }
          // Only push filterObject if it was created (not null)
          // console.log(filterObject);
          if (filterObject) {
            filters.push(filterObject);
          }
        } else {
          console.error(
            "filter will not apply because the dataSourceID of sheet and filter is not same or null"
          );
        }
      } else {
        // console.log("filter will apply");
        switch (element.selectedOperator) {
          case "IN":
            if (!element.isAll) {
              // Only create filterObject if isAll is false
              if (element.dataType === "Date") {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.selectedFilterValues.map((selectedItem) =>
                    selectedItem === "NULL"
                      ? null
                      : selectedItem === "BLANK"
                        ? ""
                        : selectedItem
                  ),
                  operator: element.selectedOperator,
                  format: element.format,
                  fieldType,
                  formula,
                };
              } else {
                filterObject = {
                  columnName: element.columnName,
                  minValue: element.selectedFilterValues.map((selectedItem) =>
                    selectedItem === "NULL"
                      ? null
                      : selectedItem === "BLANK"
                        ? ""
                        : selectedItem
                  ),
                  operator: element.selectedOperator,
                  fieldType,
                  formula,
                };
              }
            } else {
              console.error(
                "filters isAll flag is true so filter is not present in query, only present in Redux"
              );
            }
            break;
          case "BETWEEN":
            if (element.dataType === "Date") {
              if (element.isRelativeDate) {
                // // console.log("relative is true");
                // console.log(element.relativeDateIs, element.dateUnit);
                const result = breakValue(element.relativeDateIs, "buildQuery");
                if (result) {
                  const { period, value, unit } = result;
                  // console.log(period, value, unit);
                  const { minValue, maxValue } = lastToNextDateFunction({
                    period,
                    value,
                    unit,
                  });

                  filterObject = {
                    columnName: element.columnName,
                    operator: element.selectedOperator,
                    format: "DD/MM/YYYY",
                    minValue: minValue,
                    maxValue: maxValue,
                  };
                } else {
                  // console.log(result);
                  const { minValue, maxValue } = thisToThisDateFunction(
                    element.relativeDateIs,
                    element.dateUnit
                  );
                  filterObject = {
                    columnName: element.columnName,
                    operator: element.selectedOperator,
                    format: "DD/MM/YYYY",
                    minValue: minValue,
                    maxValue: maxValue,
                  };
                }
              } else {
                // buildReduxState minValue and maxValue is alreadyPrsent
                if (element.minValue && element.maxValue) {
                  // console.log({
                  //   columnName: element.columnName,
                  //   operator: element.selectedOperator,
                  //   format: "DD/MM/YYYY",
                  //   minValue: element.minValue,
                  //   maxValue: element.maxValue,
                  // });

                  // filterObject = {
                  //   columnName: element.columnName,
                  //   operator: element.selectedOperator,
                  //   format: "DD/MM/YYYY",
                  //   minValue:element.minValue,
                  //   maxValue: element.maxValue,
                  // };
                }
              }
            } else {
              filterObject = {
                columnName: element.columnName,
                minValue: element.minValue,
                maxValue: element.maxValue,
                operator: element.selectedOperator,
                measure: element.selectedMeasure,
                fieldType,
                formula,
              };
            }
            break;
          default:
            filterObject = {
              columnName: element.columnName,
              minValue: element.minValue,
              operator: element.selectedOperator,
              measure: element.selectedMeasure,
              fieldType,
              formula,
            };
            break;
        }
        // Only push filterObject if it was created (not null)
        if (filterObject) {
          filters.push(filterObject);
        }
      }
    });
  }

  if (filters.length) {
    // console.log(filters.length);

    queryBody.filters = filters;
  }

  const chartTypes = [
    "piechart",
    "linechart",
    "areachart",
    "stackedbarchart",
    "scatterchart",
    "combochart",
    "stackedbarchartimage",
    "funnelchart",
    "disktreechart",
    "wordcloudchart",
    "heatmapchart",
    "table",
  ];
  let conditionForSort = false;
  if (chartTypes.includes(vizType) && rowsReduxArray.length === 0) {
    if (checkIfItemExists(sortProperties)) {
      conditionForSort = true;
    } else {
      conditionForSort = false;
    }
  }
  if (
    ["simpleTable", "table"].includes(vizType) &&
    columnsReduxArray.length === 0
  ) {
    if (checkIfItemExists(sortProperties)) {
      conditionForSort = true;
    } else {
      conditionForSort = false;
    }
  }

  // console.log(conditionForSort);
  if (conditionForSort) {
    // console.log(sortProperties);
    // console.log(sortProperties.length);
    if (vizType === "cordinatemap") {
      let sortObject = { isRandomSort: true };
      sortBy.push(sortObject);
    } else {
      sortProperties.forEach((element) => {
        let sortObject = null;
        sortObject = {
          columnName: element.column,
          order: element.order,
          customOrder: element.customOrder,
          format: element.format,
          yearType: element.yearType,
        };
        // console.log(element.column.includes(element.format));
        if (element.column.includes(element.format)) {
          const requiredColumn = element.column.split(element.format)[0];
          // console.log(requiredColumn);
          sortObject.columnName = requiredColumn;
        }
        // console.log(sortObject);
        if (sortObject) {
          sortBy.push(sortObject);
        }
      });
    }
    queryBody.sortBy = sortBy;
  } else {
    sortBy = buildSortObject(vizType, groupByKeys, rowKeys);
    // console.log(sortBy);
  }
  queryBody = sortBy.length ? { ...queryBody, sortBy } : queryBody;
  // console.log(queryBody);
  return { queryBody: { ...queryBody, user_id }, rowKeys, groupByKeys, valueKeys, toolTipKeys };
};
